/**
 * 3D柱状图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const bar3DValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: ['string', 'date'], required: true },
    { field: 'z', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'bar3d-sufficient-data',
      validator: data => Array.isArray(data) && data.length >= 4,
      message: '3D bar chart requires at least 4 data points for meaningful 3D visualization',
      suggestion: 'Provide at least 4 data points to form a proper 3D grid structure',
      severity: 'warning'
    },
    {
      name: 'bar3d-grid-completeness',
      validator: (data, layer) => {
        if (!Array.isArray(data) || data.length < 2) {
          return true;
        }

        const { encoding } = layer;
        // 检查是否形成合理的网格结构
        const xValues = new Set(data.map(item => String(item[encoding?.x as string] || '')));
        const yValues = new Set(data.map(item => String(item[encoding?.y as string] || '')));

        // 如果数据点数量远小于网格可能的组合，给出建议
        const expectedGridSize = xValues.size * yValues.size;
        return data.length >= Math.min(expectedGridSize * 0.5, 4);
      },
      message: '3D bar chart works best with data that forms a relatively complete grid',
      suggestion:
        'Consider providing data points that cover most x-y combinations for better 3D effect',
      severity: 'warning'
    }
  ]
};
